export default __webpack_public_path__ + "static/media/image-1@3x.a37f8aa6.png";